import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { isRequired, validateNumber } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import TextInput from '../../../common/forms/input/TextInput';
import LocationSelect from '../../../common/forms/select/LocationSelect';
import BusinessInputGroup from '../../../common/forms/BusinessInputGroup';

const FORM_NAME = 'TollForm';
export const TollForm = ({ handleSubmit, loading }) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Nombre" required>
          <Field
            name="locationId"
            component={LocationSelect}
            placeholder="Nombre"
            validate={[isRequired]}
            isToll
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Precio por eje" required>
          <Field
            name="pricePerAxle"
            component={TextInput}
            placeholder="Precio por eje"
            validate={[isRequired, validateNumber]}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Impuesto prepago por eje" required>
          <Field
            name="taxPrePaymentPerAxle"
            component={TextInput}
            placeholder="Impuesto prepago por eje"
            validate={[isRequired, validateNumber]}
          />
        </FormItem>
      </FormGroup>
      <BusinessInputGroup
        label="Empresa"
        name="business"
        form="TollForm"
        showDetails
        isClearable
      />
      <FormGroup row>
        <FormItem label="Provia">
          <Field name="provia" component="input" type="checkbox" />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Peaje electrónico">
          <Field name="electronic" component="input" type="checkbox" />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Extraordinario">
          <Field name="isExtraordinary" component="input" type="checkbox" />
        </FormItem>
      </FormGroup>

      <FormFooter />
    </Form>
  );
};
TollForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};
const selector = formValueSelector(FORM_NAME);
const mapStateToProps = (state) => ({
  loading: !state.MechanicalMaintenanceUnit.Material.getIn([
    'current',
    'activity',
  ]).isEmpty(),
  electronic: selector(state, 'electronic'),
});
const formComponent = reduxForm({
  form: FORM_NAME,
  initialValues: { electronic: false, isExtraordinary: false },
})(TollForm);
export default connect(mapStateToProps)(formComponent);
